import React from "react";
import { Link } from "react-router-dom";
import withContentFallback from "../../utils/withContentFallback";
import { welcomeContent } from "../../constants/homePageContent";
import "./Welcome.css";

const Welcome = ({ content }) => {
  // No need for manual fallback, content already processed by HOC
  const {
    heading,
    tagline,
    text,
    primaryButtonText,
    primaryButtonLink,
    secondaryButtonText,
    secondaryButtonLink,
  } = content;

  return (
    <section className="welcome-section section animate-on-scroll">
      <div className="container">
        <div className="welcome-content">
          <h2>{heading}</h2>
          <p className="tagline">{tagline}</p>
          <div className="divider"></div>
          <p className="welcome-text">{text}</p>
          <div className="welcome-cta">
            <Link to={primaryButtonLink} className="btn btn-primary">
              {primaryButtonText}
            </Link>
            <Link to={secondaryButtonLink} className="btn btn-secondary">
              {secondaryButtonText}
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};

// Wrap the component with withContentFallback HOC
export default withContentFallback(Welcome, welcomeContent);
